export default function useCompleteStrapiUrl() {
  const runtimeConfig = useRuntimeConfig();
  const baseStrapiUrl = runtimeConfig.public.strapi.url;

  const isValidUrl = (urlString: string) => {
    try {
      new URL(urlString);

      return true;
    } catch (err) {
      return false;
    }
  };

  const getCompleteUrl = (url: string) => {
    if (isValidUrl(url)) {
      return url;
    }

    return `${baseStrapiUrl}${url}`;
  };

  return {
    getCompleteUrl,
  };
}
